<template>  
    <b-alert variant="danger" show>
      <b-link href="http://www.graudissenydigitalitec.udl.cat/">Grado Diseño Digital y Tecnologías Creativas</b-link> 
    || 
      <b-link href="http://www.udl.cat/">Universitat de Lleida</b-link>.

    </b-alert>
</template>

<script>
export default {


}
</script>


<style scoped>

</style>